module.exports = __webpack_public_path__ + "static/Frogsong2-cb7403743e3750a9d91aa44ad8a01307.webp";